"use strict";
// THIS FILE IS AUTO-GENERATED BY THE ANALYTICS CODEGEN SCRIPT
// DO NOT MANUALLY MODIFY THIS FILE
// FOR MORE INFORMATION CHECK OUT: https://github.com/flexapp/genoa/pull/5762
exports.__esModule = true;
exports.RentPortalAddressSuggestedClickedAnalyticsEvent = exports.RentPortalAddressOriginalClickedAnalyticsEvent = exports.RentPortalAddressModalClickedAnalyticsEvent = exports.RentPortalAddressContinueClickedAnalyticsEvent = exports.PropertySearchCantFindClickedAnalyticsEvent = exports.PropertySearchAddressSearchPerformedAnalyticsEvent = exports.OonHowYouPayCtaClickedAnalyticsEvent = exports.OonHowFlexWorksCtaClickedAnalyticsEvent = exports.DirectIntegrationUnitsSelectedCtaAnalyticsEvent = exports.DirectIntegrationUnitsNoneCtaAnalyticsEvent = exports.DirectIntegrationUnitsConfirmedCtaAnalyticsEvent = exports.DirectIntegrationConfirmRestartCtaAnalyticsEvent = exports.BillerConnectionSuccessAnalyticsEvent = exports.BillerConnectionStartAnalyticsEvent = exports.BillerConnectionFailAnalyticsEvent = exports.AddressSelectionPredictionSelectedAnalyticsEvent = void 0;
var util_1 = require("./util");
/**
 * Triggers when customer clicks on the CTA 'My property isn't listed' on the 'Search for your property' screen
 */
var PropertySearchCantFindClickedAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('property_search_cant_find_clicked');
exports.PropertySearchCantFindClickedAnalyticsEvent = PropertySearchCantFindClickedAnalyticsEvent;
/**
 * Triggers when user enters a property and we attempt to provide results on the 'Search for your property' screen
 */
var PropertySearchAddressSearchPerformedAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('property_search_address_search_performed');
exports.PropertySearchAddressSearchPerformedAnalyticsEvent = PropertySearchAddressSearchPerformedAnalyticsEvent;
/**
 * Triggers when user clicks on a property from the list on the 'Search for your property' screen
 */
var AddressSelectionPredictionSelectedAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('address_selection_prediction_selected');
exports.AddressSelectionPredictionSelectedAnalyticsEvent = AddressSelectionPredictionSelectedAnalyticsEvent;
/**
 * Trigger when user clicks on a unit from the list on the 'Which unit do you live in' screen
 */
var DirectIntegrationUnitsSelectedCtaAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('direct_integration_units_selected_cta');
exports.DirectIntegrationUnitsSelectedCtaAnalyticsEvent = DirectIntegrationUnitsSelectedCtaAnalyticsEvent;
/**
 * Triggers when user clicks on 'Continue' on the 'Which unit do you live in' screen
 */
var DirectIntegrationUnitsConfirmedCtaAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('direct_integration_units_confirmed_cta');
exports.DirectIntegrationUnitsConfirmedCtaAnalyticsEvent = DirectIntegrationUnitsConfirmedCtaAnalyticsEvent;
/**
 * Triggers when user clicks 'None of the above' on the 'Which unit do you live in' screen
 */
var DirectIntegrationUnitsNoneCtaAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('direct_integration_units_none_cta');
exports.DirectIntegrationUnitsNoneCtaAnalyticsEvent = DirectIntegrationUnitsNoneCtaAnalyticsEvent;
/**
 * Trigger when user clicks 'Not your address' on the 'Confirm your address' screen
 */
var DirectIntegrationConfirmRestartCtaAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('direct_integration_confirm_restart_cta');
exports.DirectIntegrationConfirmRestartCtaAnalyticsEvent = DirectIntegrationConfirmRestartCtaAnalyticsEvent;
/**
 * Trigger after the user clicks on 'Continue' on the 'Confirm your address' screen and indicates attempt to complete biller connection
 */
var BillerConnectionStartAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('biller_connection_start');
exports.BillerConnectionStartAnalyticsEvent = BillerConnectionStartAnalyticsEvent;
/**
 * Triggers when biller connect attempt completes and is successful
 */
var BillerConnectionSuccessAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('biller_connection_success');
exports.BillerConnectionSuccessAnalyticsEvent = BillerConnectionSuccessAnalyticsEvent;
/**
 * Triggers when biller connect attempt fails
 */
var BillerConnectionFailAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('biller_connection_fail');
exports.BillerConnectionFailAnalyticsEvent = BillerConnectionFailAnalyticsEvent;
/**
 * Triggers when the Flex Anywhere 'What's your address' screen > Suggested Address modal is opened or closed
 */
var RentPortalAddressModalClickedAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('rent_portal_address_modal_clicked');
exports.RentPortalAddressModalClickedAnalyticsEvent = RentPortalAddressModalClickedAnalyticsEvent;
/**
 * Triggers when customer clicks on the CTA 'Continue' on the Flex Anywhere 'What's your address' screen and all required address fields are populated
 */
var RentPortalAddressContinueClickedAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('rent_portal_address_continue_clicked');
exports.RentPortalAddressContinueClickedAnalyticsEvent = RentPortalAddressContinueClickedAnalyticsEvent;
/**
 * Triggers when user clicks on the CTA 'Use suggested address' on the Flex Anywhere 'What's your address' screen > Suggested Address modal
 */
var RentPortalAddressSuggestedClickedAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('rent_portal_address_suggested_clicked');
exports.RentPortalAddressSuggestedClickedAnalyticsEvent = RentPortalAddressSuggestedClickedAnalyticsEvent;
/**
 * Triggers when user clicks on the CTA 'Use original address' on the Flex Anywhere 'What's your address' screen > Suggested Address modal
 */
var RentPortalAddressOriginalClickedAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('rent_portal_address_original_clicked');
exports.RentPortalAddressOriginalClickedAnalyticsEvent = RentPortalAddressOriginalClickedAnalyticsEvent;
/**
 * Triggers when user clicks on the CTA 'Got it' on the Flex Anywhere Introduction Screen
 */
var OonHowYouPayCtaClickedAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('oon_how_you_pay_cta_clicked');
exports.OonHowYouPayCtaClickedAnalyticsEvent = OonHowYouPayCtaClickedAnalyticsEvent;
/**
 * Triggers when user clicks on CTA 'Got it' for Flex Anywhere How It Works screen
 */
var OonHowFlexWorksCtaClickedAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('oon_how_flex_works_cta_clicked');
exports.OonHowFlexWorksCtaClickedAnalyticsEvent = OonHowFlexWorksCtaClickedAnalyticsEvent;
